let articleData = document.querySelector('[type="application/json"][data-article-json]');
console.log("test")
if(articleData){
    let articleJson = JSON.parse(articleData.textContent),
        articleSorted = articleArraySorting(articleJson,'created-descending');
    articlePageSorting(articleSorted);
    if(document.querySelector('.js-article-sorting')){
        document.querySelector('.js-article-sorting').addEventListener('change',function (){
            let newArray = articleArraySorting(articleJson,this.value);
            articlePageSorting(newArray);
        })
    }
}
function articleArraySorting(array, sort_by){
    if(sort_by == "title-descending"){
        return array.sort((a, b) => a.title.localeCompare(b.title)).reverse();
    }else if(sort_by == "title-ascending"){
        return array.sort((a, b) => a.title.localeCompare(b.title));
    }else if(sort_by == "created-descending"){
        return array.sort(function(a,b){return new Date(b.date) - new Date(a.date);});
    }else if(sort_by == "created-ascending"){
        return array.sort(function(a,b){return new Date(b.date) - new Date(a.date);}).reverse();
    }else{
        return array
    }
}
function articlePageSorting(array){
    if(array){
        array.forEach(function (item, index){
            if(document.querySelector(`[data-article-hande="${item.id}"]`)){
                document.querySelector(`[data-article-hande="${item.id}"]`).style.order = index+1
            }
        })
    }
}